import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useState, useRef, useMemo } from 'react';
import JoditEditor from 'jodit-react';
import { useAddNewassetReqMutation } from '../../../features/assetrequest/assetReqApiSlice';
import { useGetUsersQuery } from '../../../features/users/usersApiSlice';
import useAuth from '../../../features/hooks/useAuth';
import { useGetAssetMastersQuery } from '../../../features/assetmasterApiSlice/assetmasterApiSlice';
import { useGetAssetsFinalQuery, useUpdateAssetintransitMutation } from '../../../features/addassets/addassetfinalApiSlice';
import CustomPaginationActionsTable from './StoretoStoreReqTable'
import { useGetofficesQuery } from '../../../features/offices/officesApiSlice';
import Select from 'react-select';
import { useGetStoreOfficesQuery } from '../../../features/storeoffices/storeofficesApiSlice'
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import ReactTooltip from "react-tooltip";
import moment from 'moment'
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useNavigate } from "react-router-dom";
import { HeadingWrap, Span, CommonButton, PreDataWrap, IntReqWrapper, AddRemarkButton, BackButtonSpan, StoreNameCont, ExtReqWrapper, PopupButton } from '../../../Styles/CommonStyles'


const Container = styled.div``
const Wrapper = styled.div``
const RequestWrapper = styled.div``
const Styledlabel = styled.label`
font-size: 20px;
font-weight: 200;
`
const TextInputWrap = styled.div`
height: 30vh;
`
const SubmitButton = styled(CommonButton)``
const SelectContainer = styled.div`
width: 100%;
margin: 15px;
display: flex;
align-items: center;
`
const CurrSelAssetsCont = styled.div``
const Option = styled.option`
font-size: 15px;
font-weight: 100;
`
const CatSelect = styled.select`
width: 30%;
height: 35px;
`
const SubcatSelect = styled.select`
width: 30%;
height: 30px;
`
const AssetNameselCon = styled.div`
height: 15vh;
`
const AssetTagselCon = styled.div`
display: flex;
`
const AllStoreAssetsTableCont = styled.div``
const StyledPopup = styled(Popup)`
  // use your custom style for ".popup-content"
  &-content {
    margin: auto;
  background: rgb(255, 255, 255);
  width: 60%;
  padding: 5px;}
`

// table style
const tableStyle = {
  width: '53%',
  borderCollapse: 'collapse',
  marginTop: '20px',
};

const thTdStyle = {
  border: '1px solid #ddd',
  padding: '8px',
  textAlign: 'left',
  fontSize: '20px'
};

const thStyle = {
  backgroundColor: '#aae2e4',
  fontSize: '23px'
};

const evenRowStyle = {
  backgroundColor: '#f9f9f9',
};


const StoreToStoreReq = () => {
  const [content, setContent] = useState('');
  const editor = useRef(null);
  const [selectedOptions, setSelectedOptions] = useState();
  const [selectedStore, setSelectedStore] = useState()

  //logged in user data
  const { id, email, designation, designationSuffix, numSuffix, roles } = useAuth()
  let user_current_office = (useSelector((state) => state.office.off))
  let user_current_role_array = roles[user_current_office]


  function handleSelectTags(data) {
    setSelectedOptions(data);
  }

  // assetmaster call
  const {
    data: assetmasters,
    isLoading: assetmastLoad,

  } = useGetAssetMastersQuery('assetmasterlist', {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true
  });
  let tempdata = assetmasters ? Object.values(assetmasters?.entities) : []

  // all office call
  const {
    data: allofficedata,
    isLoading: allofficeLoad,
  } = useGetofficesQuery('officelist', {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true
  });

  //get single assets
  const { getSingleasset } = useGetAssetsFinalQuery('allassetlist', {
    selectFromResult: ({ data }) => ({
      getSingleasset: data?.entities
    }),
  })


  //store offices 
  const {
    data: allstoreoffices
  } = useGetStoreOfficesQuery('allstorelists', {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true
  });

  let allstoresdata = allstoreoffices ? Object.values(allstoreoffices?.entities) : []

  let officeOptionList = allstoresdata?.map(elm => elm.storeoffice)

  const data = tempdata
  //usercall/single user call
  const { getSingleuser } = useGetUsersQuery('userslist', {
    selectFromResult: ({ data }) => ({
      getSingleuser: data?.entities
    }),
  })

  // find applicable categories based on user store
  let senderStoreDoc = allstoresdata?.filter(elm => elm.storeoffice === user_current_office)
  let applCatarray = senderStoreDoc[0]?.ApplAssetCateg

  // find store doc of recieveing store
  // selcted store name which is office name also
  let selectedStoreName = selectedStore
  let selectedStoreDoc = allstoresdata?.filter(elm => elm.storeoffice === selectedStoreName)[0]
  let selectedStoreManId = selectedStoreDoc?.roleUsers?.level1approver
  let selectStoreManDoc = getSingleuser && getSingleuser[selectedStoreManId]

  // add mutation call
  const [addNewRequest, { isLoading: addNewRequestloading }] = useAddNewassetReqMutation()
  //assets in transit status update call 
  const [updateAssetinTran, { isLoading: updateAssetinTranloading }] = useUpdateAssetintransitMutation()


  //selcted assets IDs array
  let selectedAssetsIdArray = selectedOptions?.map(elm => elm.value)
  let selectedassets = selectedAssetsIdArray?.map(elm => { return getSingleasset && getSingleasset[elm] })

  //in transit body 
  let assetTranBody = { selectedAssetarray: selectedAssetsIdArray, transtatus: true }

  // create send to the assetmanager level-1 of the selected store
  let sendToStoreManObj = { id: selectedStoreManId, name: getSingleuser && getSingleuser[selectedStoreManId]?.name, office: selectedStoreName, designation: getSingleuser && getSingleuser[selectedStoreManId]?.designation[selectedStoreName], designationSuffix: getSingleuser && getSingleuser[selectedStoreManId]?.designationSuffix[selectedStoreName], numSuffix: getSingleuser && getSingleuser[selectedStoreManId]?.numSuffix[selectedStoreName] }

//************************************************************************ */
    //create a unique Id
    const uniqueReqID = () => {
      const dateString = Date.now().toString(36);
      const emailofuser = getSingleuser && getSingleuser[id]?.email?.slice(0, -8)
      const uid = `${emailofuser}-${dateString}`
      return uid;
  };

  let uniqueReqId = uniqueReqID()
  //****************************************************************************** */

  let userReqData = {
    uniqueReqId: uniqueReqId,
    req_type: 'str_to_str',
    req_cat: 'bySMtoSM',
    req_creator: { id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
    req_office: "",
    sender_store: user_current_office,
    req_store: selectedStoreName,
    sent_to_tag: 'level_1_approver',
    curr_status: 'pending',
    created_at: new Date(),
    curr_sent_by: { id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
    curr_sent_to: sendToStoreManObj,
    req_data: [{
      // save all assets 
      assets_details: selectedAssetsIdArray,
      Text: content,
      sent_by: { id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
      sent_to: sendToStoreManObj,
      status: 'pending',
      time_stamp: new Date()
    }]
  }

  const navigate = useNavigate();

  // submit request
  const handleReqSubmit = async () => {
    if (selectedStoreManId) {
      try {
        await addNewRequest(userReqData).unwrap()
        await updateAssetinTran(assetTranBody)
        navigate('/management/assets/AssetMan')
        return alert('your request is forwarded to the store manager of selected store')
      } catch (err) {
        return alert(`Error:${err}`)
      }
    } else {
      return alert('Store manager is not available. Please register Store manager')
    }
  }


  return (
    <Container>
      <Wrapper>
        <StyledPopup
          trigger={<PopupButton style={{ width: 300 }} className="button"> Go to store to select Assets </PopupButton>}
          modal
          nested
        >
          <AllStoreAssetsTableCont>
            <CustomPaginationActionsTable selectedOptions={selectedOptions} setSelectedOptions={setSelectedOptions} />
          </AllStoreAssetsTableCont>
        </StyledPopup>
        <RequestWrapper>
          <TextInputWrap>
            <HeadingWrap><Span>Details/Justifications</Span></HeadingWrap>
            <JoditEditor
              ref={editor}
              value={content}
              onBlur={newContent => setContent(newContent)}
              onChange={newContent => { }}
            />
          </TextInputWrap>
          <div className="app">
            <h3> </h3>
            <Autocomplete
              id="combo-box-demo"
              options={officeOptionList}
              sx={{ width: 600 }}
              value={selectedStore}
              onChange={(event, newValue) => {
                setSelectedStore(newValue);
              }}
              renderInput={(params) => <TextField {...params} label="Please Select Store office to Transfer Assets" />}
            />
          </div>
          {selectedStore && <Span> Details of Asset Manager of selected office:-
            {selectedStoreManId && `${selectStoreManDoc?.name.firstName} ${selectStoreManDoc?.name.middleName} ${selectStoreManDoc?.name.firstName}- ${selectStoreManDoc?.designation[selectedStore]}`}</Span>}

            {selectedassets?.length > 0 && <CurrSelAssetsCont>
            <Span> Selected Assets to be issued:</Span>
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={{ ...thTdStyle, ...thStyle }}>Assets</th>
                  <th style={{ ...thTdStyle, ...thStyle }}>OEM Tags</th>
                  <th style={{ ...thTdStyle, ...thStyle }}>OEM/Brand</th>
                  <th style={{ ...thTdStyle, ...thStyle }}>Purchase Date</th>
                  <th style={{ ...thTdStyle, ...thStyle }}>Warranty Date</th>
                  <th style={{ ...thTdStyle, ...thStyle }}>Specifications</th>
                </tr>
              </thead>
              <tbody>
                {selectedassets?.map((row, index) => (
                  <tr key={index} style={(index + 1) % 2 === 0 ? evenRowStyle : null}>
                    <td style={thTdStyle}>{row.name}</td>
                    <td style={thTdStyle}>{row.oem_tag}</td>
                    <td style={thTdStyle}>{row.oem}</td>
                    <td style={thTdStyle}>{moment(row.purchase_date).format('DD/MM/YYYY')}</td>
                    <td style={thTdStyle}>{moment(row.warrantyexp_date).format('DD/MM/YYYY')}</td>
                    <td style={thTdStyle}><div className="App">
                      <div data-tip data-for={row._id}>
                        Hover here to view Specifications
                      </div>
                      <ReactTooltip id={row._id} place="top" effect="solid">
                        <div>
                          {Object.entries(row.specification).map(([key, val]) => <h4 key={key}>{key}: {val}</h4>)}
                        </div>
                      </ReactTooltip>
                    </div></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </CurrSelAssetsCont>}
        </RequestWrapper>
        <SubmitButton onClick={handleReqSubmit}>Sent to Store Manager of selected store</SubmitButton>
      </Wrapper>
    </Container>
  )
}


export default StoreToStoreReq